"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class SingleSelectQuestionModule extends base_1.SelectModule {
    constructor(_a) {
        var { hidden = false } = _a, rest = __rest(_a, ["hidden"]);
        super(rest);
        this._type = "SingleSelectQuestion";
        this.hidden = hidden;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const userValues = [];
            const builderModule = {
                actionRequired: this.actionRequired,
                id: this.id,
                label: this.label,
                options: this.options.map((opt) => {
                    const option = {
                        id: opt.id || (0, util_1.generateUUID)(),
                        label: opt.label,
                    };
                    if (opt.userDefined) {
                        userValues.push(opt.id || (0, util_1.generateUUID)());
                        option.userDefined = true;
                    }
                    return option;
                }),
                required: this.required,
                type: this.type,
            };
            if (this.hidden) {
                this.hidden = true;
            }
            return builderModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        if (this.validate()) {
            const userValues = [];
            const configModule = {
                actionRequired: this.actionRequired,
                id: this.id,
                header: { children: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
                options: this.options.map((opt) => {
                    var _a;
                    const option = {
                        id: opt.id || (0, util_1.generateUUID)(),
                        label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    };
                    if (opt.userDefined) {
                        userValues.push(opt.id || (0, util_1.generateUUID)());
                        option.userDefined = true;
                    }
                    return option;
                }),
                type: this.type,
                noBorder: this.noBorder,
            };
            if (this.required) {
                configModule.validation = (0, util_1.addRequiredValidation)();
            }
            if (this.hidden) {
                this.hidden = true;
            }
            return configModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            options: this.options.map((opt) => {
                var _a;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    userDefined: opt.userDefined,
                });
            }),
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            actionRequired: this.actionRequired,
        };
    }
}
exports.SingleSelectQuestionModule = SingleSelectQuestionModule;
//# sourceMappingURL=SingleSelectQuestion.js.map